import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_2 = { class: "d-inline-block text-end font-monospace text-nowrap cash-value fs-5" }
const _hoisted_3 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_4 = { class: "d-inline-block text-end font-monospace text-nowrap cash-value fs-5" }
const _hoisted_5 = { class: "d-inline-block text-end font-monospace text-nowrap cash-value fs-5" }
const _hoisted_6 = { class: "d-inline-block text-end font-monospace text-nowrap cash-value fs-5" }

import { ref, computed, watch, PropType } from "vue";
import TaxFreeCashModelSupporter from "@/guiide/ts/assets/finalsalary/taxFreeCashModelSupporter";
import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";
import { formatter } from "@/shared/ts/formatter";
import { useFinalSalaryStaticOptions } from "@/guiide/ts/assets/finalsalary/useFinalSalaryOptionInfoStatic";


export default /*@__PURE__*/_defineComponent({
  __name: 'TaxFreeLumpSumDescriber',
  props: {
    model: { type: TaxFreeCashModelSupporter, required: true },
    selectedOption: { type: Number as PropType<FinalSalaryOption>, required: true }
},
  setup(__props) {

const props = __props;

const standard = ref<number>(props.model.getActual(FinalSalaryOption.SchemeDefault));
const pieValue = ref<number>(props.model.getActual(FinalSalaryOption.PensionIncreaseExchange));
const bpValue = ref<number>(props.model.getActual(FinalSalaryOption.BridgingPension));

const { finalSalaryOptionsStatic } = useFinalSalaryStaticOptions();
const pieText = ref(finalSalaryOptionsStatic.value.pensionIncreaseExchange.abbreviation);
const bpoText = ref(finalSalaryOptionsStatic.value.bridgingPension.abbreviation);

watch(
    () => props.model.selected,
    () => {
        standard.value = props.model.getActual(FinalSalaryOption.SchemeDefault);
        pieValue.value = props.model.getActual(FinalSalaryOption.PensionIncreaseExchange);
        bpValue.value = props.model.getActual(FinalSalaryOption.BridgingPension);
    }
);

const showSingleValueOnly = computed<boolean>(() => !props.model.optionsHaveDifferentMax);

const showPIE = computed<boolean>(() => props.selectedOption == FinalSalaryOption.PensionIncreaseExchange);
const showBP = computed<boolean>(() => props.selectedOption == FinalSalaryOption.BridgingPension);


return (_ctx: any,_cache: any) => {
  return (showSingleValueOnly.value)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _cache[0] || (_cache[0] = _createTextVNode(" Tax free cash: ")),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(formatter).formatCurrency(standard.value)), 1)
      ]))
    : (_openBlock(), _createElementBlock("p", _hoisted_3, [
        _cache[1] || (_cache[1] = _createTextVNode(" Standard: ")),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatter).formatCurrency(standard.value)), 1),
        (showPIE.value || showBP.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(", ")
            ], 64))
          : _createCommentVNode("", true),
        (showPIE.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(pieText.value) + ": ", 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatter).formatCurrency(pieValue.value)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (showBP.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(bpoText.value) + ": ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatter).formatCurrency(bpValue.value)), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]))
}
}

})